import { render, staticRenderFns } from "./myPage.vue?vue&type=template&id=2840102e&scoped=true&"
import script from "./myPage.vue?vue&type=script&lang=js&"
export * from "./myPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2840102e",
  null
  
)

export default component.exports